module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-14.6f0a8c63.png";